import React, { useRef, useState } from 'react'
import "./Contact.css"
import { MdOutlineEmail } from 'react-icons/md'
import { BsWhatsapp } from 'react-icons/bs'
import emailjs from '@emailjs/browser'

const Contact = () => {
  const formRef = useRef(null);
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await emailjs.sendForm(
        'service_ls5atni',      
        'template_gt1lvvh',
        formRef.current,
        'TNZwT-iJ7WVEgexGL'    
      );

      alert('✅ Message sent! Please check your email to ensure you have received the auto-reply');
      formRef.current.reset();
    } catch (err) {
      console.error('EMAILJS ERROR:', err?.text || err);
      alert('❌ Failed to send. Check console for details.');
    } finally {
      setSending(false);
    }
  };

  return (
    <section id='contact'>
      <div className="section__wrapper contact__container">
        <div className="section__header">
          <h2 className="primary__title">Contact Me</h2>
          <p className='text__muted description'>
            I would love the opportunity to contribute to your team.
            With hands-on experience across React, Node.js and cross-platform development (React Native & Flutter), I focus on building 
            scalable, maintainable products and collaborating closely in Agile environments. I am proactive, open to feedback, and committed to delivering impact.
            If there is a fit, I would be excited to discuss how I can help your team ship faster and better.
          </p>
        </div>

        <div className="contact__group">
          <div className="contact__options">
            <article className='contact__option'>
              <MdOutlineEmail className='contact__icon'/>
              <h3>Email</h3>
              <h5>sheedshirazi@gmail.com</h5>
              <a href='mailto:mahshid.ebrahimshirazi@gmail.com' target='_blank' rel="noreferrer" className='btn'>Send A Message</a>
            </article>
            <article className='contact__option'>
              <BsWhatsapp className='contact__icon'/>
              <h3>WhatsApp</h3>
              <a href='https://wa.me/14378711181?text=Hi%20Mahshid!' target='_blank' rel="noreferrer" className='btn'>Message on WhatsApp</a>
            </article>
          </div>
          <form ref={formRef} onSubmit={handleSubmit}>
            <input type='text' name='from_name' placeholder='Your Full Name' required />
            <input type='email' name='from_email' placeholder='Your Email' required />
            <textarea name='message' rows={7} placeholder='Your Message' required></textarea>

            <button type='submit' className='btn btn__primary' disabled={sending}>
              {sending ? 'Sending…' : 'Send Message'}
            </button>
          </form>
        </div>
      </div>
    </section>
  )
}

export default Contact
